<template>
  <div id="credit-user">
    <div class="breadcrumb">
      数据统计
      <!-- <el-button class="right_f" type="primary">导出</el-button> -->
    </div>

    <div class="search-box">
      <el-select class="apply-search-item" v-model="applyStatus">
        <el-option label="全部状态" value="0"></el-option>
        <el-option label="申请中" value="1"></el-option>
        <el-option label="申请通过" value="2"></el-option>
        <el-option label="申请失败" value="3"></el-option>
        <el-option label="已激活" value="4"></el-option>
      </el-select>
      <span style="padding-left: 20px">申请时间：</span>
      <el-date-picker
        class="my-time"
        v-model="time"
        type="daterange"
        :picker-options="pickerOptions"
      >
      </el-date-picker>

      <el-button type="primary" @click="searchApplyUserList">搜索</el-button>
    </div>

    <div class="com-list">
      <el-table :data="applyUserList" style="overflow-x: auto">
        <el-table-column
          prop="applyId"
          label="申请编号"
          width="100"
        ></el-table-column>
        <el-table-column
          prop="code"
          label="渠道ID"
          width="140"
        ></el-table-column>
        <!-- <el-table-column prop="uid" label="UID"  width="100"></el-table-column> -->
        <el-table-column prop="name" label="姓名"></el-table-column>
        <el-table-column
          prop="phone"
          label="手机号"
          width="130"
        ></el-table-column>
        <el-table-column prop="applyTime" label="申请时间"></el-table-column>
        <el-table-column prop="applyStatus" label="申请状态"></el-table-column>
        <el-table-column
          inline-template
          prop="lastApplyStatus"
          label="修改前状态"
        >
          <div>{{ row.lastApplyStatus }} {{ row.lastupdateTime }}</div>
        </el-table-column>
        <el-table-column inline-template prop="operateName" label="修改人">
          <div v-if="row.operateName">
            {{ row.operateName }} {{ row.updateTime }}
          </div>
        </el-table-column>
        <el-table-column inline-template label="操作">
          <el-button @click="editApplyStatus(row)">编辑</el-button>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination">
      <el-pagination
        v-show="totalCount > 0"
        layout="prev, pager, next, jumper"
        :page-size="pageSize"
        :current-page="pageNum"
        :total="totalCount"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>

    <el-dialog
      title="修改用户申请状态"
      v-model="dialogFormVisible"
      :modal-append-to-body="false"
    >
      <el-form :model="applyFrom">
        <el-form-item label="状态：" :label-width="formLabelWidth">
          <el-select class="apply-search-item" v-model="applyFrom.applyStatus">
            <el-option label="申请中" value="1"></el-option>
            <el-option label="申请通过" value="2"></el-option>
            <el-option label="申请失败" value="3"></el-option>
            <el-option label="已激活" value="4"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateApplyStatus">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      applyStatus: "0",
      keyword: "",
      time: "",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      startTime: new Date(),
      endTime: new Date(),
      pageSize: 20,
      pageNum: 1,
      totalCount: 0,
      applyUserList: [],
      formLabelWidth: "120px",
      applyFrom: {
        applyStatus: "2",
      },
      updateApplyId: "",
      dialogFormVisible: false,
    };
  },
  computed: mapState({ user: (state) => state.user }),
  mounted() {
    this.searchApplyUserList();
  },
  methods: {
    searchApplyUserList(num) {
      let url =
        this.$util.nodeDomain + "/h5/activity/creditCard/applyuser/list";

      this.applyUserList = [];
      if (!num) {
        this.pageNum = 1;
      }
      let startTime = 0,
        endTime = 0;
      if (this.time && this.time.length > 0) {
        startTime = new Date(this.time[0]).getTime();
        endTime = new Date(
          new Date(this.time[1]).format("yyyy/MM/dd 23:59:59")
        ).getTime();
      }

      this.$http({
        method: "POST",
        url: url,
        body: JSON.stringify({
          applyStatus: this.applyStatus * 1,
          startTime: startTime,
          endTime: endTime,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        }),
      }).then((res) => {
        if (res.data.error == 10000) {
          let preObj = res.data.data;
          this.totalCount = preObj.totalCount ? preObj.totalCount * 1 : 0;
          if (preObj.list && preObj.list.length > 0) {
            let status = ["", "申请中", "申请通过", "申请失败", "已激活"];
            preObj.list.forEach((element, index) => {
              this.applyUserList.push({
                ...element,
                uid: element.uid ? element.uid : "",
                applyStatus: status[element.applyStatus],
                lastApplyStatus: status[element.lastApplyStatus],
                applyTime: element.applyTime
                  ? new Date(element.applyTime).format("yyyy/MM/dd")
                  : "",
                updateTime: element.updateTime
                  ? new Date(element.updateTime).format("yyyy/MM/dd")
                  : "",
                lastupdateTime: element.lastupdateTime
                  ? new Date(element.lastupdateTime).format("yyyy/MM/dd")
                  : "",
              });
            });
          }
        }
      });
    },

    // 编辑
    editApplyStatus(row) {
      this.applyFrom.applyStatus = "2";
      this.updateApplyId = row.applyId;
      this.dialogFormVisible = true;
    },

    // 编辑保存
    updateApplyStatus() {
      let url =
        this.$util.nodeDomain + "/h5/activity/creditCard/applyuser/update";

      this.$http({
        method: "POST",
        url: url,
        body: JSON.stringify({
          applyId: this.updateApplyId,
          operateId: this.user.userId,
          operateName: this.user.name,
          applyStatus: this.applyFrom.applyStatus * 1,
        }),
      }).then((res) => {
        if (res.data.error == 10000) {
          this.dialogFormVisible = false;
          this.$util.successMsg("操作成功");
          this.searchApplyUserList();
        }
      });
    },

    handleCurrentChange(val) {
      this.pageNum = val * 1;
      this.searchApplyUserList(val);
    },
  },
};
</script>
<style scoped>
.search-box {
  padding: 0 20px;
  margin-bottom: 20px;
}

.apply-search-item {
  display: inline-block;
  width: 200px;
}

.my-time {
  width: 300px;
}

.apply-input {
  display: inline-block;
  width: 300px;
}
</style>



// WEBPACK FOOTER //
// criditCardUser.vue?7bd20071